<template>
  <b-row no-gutters>
    <b-modal
      id="modal-make-moderator"
      ref="modalModKey"
      :hide-header="true"
      :hide-footer="true"
      :cancel-disabled="true"
      content-class="blah"
      dialog-class="moderatorWrapper"
      body-class="moderatorBody"
    >
      <b-row
        no-gutters
        class="mod-title"
      >
        <moderator-key-icon
          :size="24"
          fill-color="#4A4A4A"
          class="icon"/>
        <span class="mod-text">
          {{ $t('MEETING.ENTER_MOD_KEY') }}
        </span>
      </b-row>
      <b-form-input
        id="mod-key-input"
        v-model="modKey"
        maxlength="4"
        autofocus
        autocomplete="off"
        :placeholder="$t('MEETING.MOD_KEY')"
        :formatter="formatter"
        class="form-control-light mod-input"/>
      <b-row
        no-gutters
        class="mod-btns"
      >
        <b-btn
          size="sm"
          variant="secondary-light"
          @click="cancelModKey">
          {{ $t('MEETING.CANCEL') }}
        </b-btn>
        <b-btn
          size="sm"
          variant="primary-light"
          style="margin-left:16px"
          @click="submitModKey">
          {{ $t('MEETING.SUBMIT') }}
        </b-btn>
      </b-row>
    </b-modal>
  </b-row>
</template>

<script>
import {ref} from "@vue/composition-api"
import ModeratorKeyIcon from "../icons/ModeratorKey"
export default {
  name: 'MakeModerator',
  components: {
    ModeratorKeyIcon,
  },
  setup(props, context) {
    const modKey = ref("")

    function cancelModKey() {
      context.refs.modalModKey.hide()
    }

    function submitModKey() {
      context.parent.putModeratorKey(modKey.value)
      modKey.value = ""
      context.refs.modalModKey.hide()
    }

    function formatter(value) {
      // remove all non-digit chars
      return value.replace(/\D/g,'');
    }

    return {
      formatter,
      modKey,
      submitModKey,
      cancelModKey
    }
  }
}
</script>
<style>
.moderatorWrapper {
  max-width: 420px;
  padding: 0;
}
.moderatorBody {
  min-height: 116px;
  background-color: #ffffff;
  padding: 16px;
  border-radius: .25rem !important;
}
.mod-title {
  width: 348px;
  margin: 16px;
}
.mod-text {
  color: #282828;
  font-weight: 600;
  line-height: 24px;
  font-size: 16px;
  margin-left: 8px;
}
.mod-input {
  width: 340px;
  height: 48px;
  margin-left: 46px;
}
.mod-btns {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}
</style>


// WEBPACK FOOTER //
// src/components/MakeModerator.vue